// Chat bubble. Agent/system copy may contain demo-authored <b> emphasis, so it
// is rendered as HTML. NOTE (phase 3): sanitize model-generated HTML before
// this point once bubbles carry LLM output rather than canned strings.

export type BubbleRole = "user" | "agent" | "system";

export function Bubble({ role, html }: { role: BubbleRole; html: string }) {
  if (role === "user") {
    // User text is plain; never render it as HTML.
    return <div className="bubble user">{html}</div>;
  }
  return <div className={`bubble ${role}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
